import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Reveal } from "./Common";

const PageHero = ({ eyebrow, title, accent, image, crumbs = [] }) => (
  <section className="relative h-[58vh] min-h-[420px] flex items-end overflow-hidden">
    <div className="absolute inset-0" style={{ backgroundImage: `url(${image})`, backgroundSize: "cover", backgroundPosition: "center" }} />
    <div className="absolute inset-0 bg-gradient-to-t from-[var(--green-deep)] via-[rgba(14,58,43,0.72)] to-[rgba(14,58,43,0.35)]" />
    <div className="relative max-w-[1360px] mx-auto px-6 md:px-10 w-full pb-16 on-green">
      <Reveal>
        <div className="flex items-center gap-2 text-xs tracking-[0.16em] uppercase text-[#e5ddca] mb-6">
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          {crumbs.map((c) => (
            <span key={c} className="flex items-center gap-2">
              <ChevronRight size={13} className="text-[#c8b98f]" />
              <span className="text-white">{c}</span>
            </span>
          ))}
        </div>
      </Reveal>
      <Reveal delay={100}>
        {eyebrow && <div className="mb-4 text-[0.7rem] tracking-[0.4em] uppercase font-medium text-[#d8cba6]">{eyebrow}</div>}
        <h1 className="font-serif-display text-5xl md:text-7xl leading-[0.95] tracking-tight text-white">
          {title} {accent && <span className="italic text-[#e7dcb8]">{accent}</span>}
        </h1>
      </Reveal>
    </div>
  </section>
);

export default PageHero;
